export type PmPeriodType =
  | "current_month"
  | "current_week"
  | "previous_week"
  | "previous_month"
  | "last_90_days"
  | "year_to_date"
  | "last_year"
  | "custom";

const fmt = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const computePeriodRange = (
  type: PmPeriodType,
  customFrom?: string,
  customTo?: string
): { dateFrom: string; dateTo: string } => {
  const now = new Date();

  switch (type) {
    case "custom":
      return { dateFrom: customFrom ?? fmt(now), dateTo: customTo ?? fmt(now) };

    case "current_week": {
      const dow = now.getDay();
      const toMonday = dow === 0 ? 6 : dow - 1;
      const monday = new Date(now);
      monday.setDate(now.getDate() - toMonday);
      return { dateFrom: fmt(monday), dateTo: fmt(now) };
    }

    case "previous_week": {
      const dow = now.getDay();
      const toMonday = dow === 0 ? 6 : dow - 1;
      const monday = new Date(now);
      monday.setDate(now.getDate() - toMonday);
      const prevMonday = new Date(monday);
      prevMonday.setDate(monday.getDate() - 7);
      const prevSunday = new Date(monday);
      prevSunday.setDate(monday.getDate() - 1);
      return { dateFrom: fmt(prevMonday), dateTo: fmt(prevSunday) };
    }

    case "previous_month": {
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return { dateFrom: fmt(start), dateTo: fmt(end) };
    }

    case "last_90_days": {
      const start = new Date(now);
      start.setDate(now.getDate() - 90);
      return { dateFrom: fmt(start), dateTo: fmt(now) };
    }

    case "year_to_date": {
      const start = new Date(now.getFullYear(), 0, 1);
      return { dateFrom: fmt(start), dateTo: fmt(now) };
    }

    case "last_year": {
      const start = new Date(now.getFullYear() - 1, 0, 1);
      const end = new Date(now.getFullYear() - 1, 11, 31);
      return { dateFrom: fmt(start), dateTo: fmt(end) };
    }

    default: {
      // current_month
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return { dateFrom: fmt(start), dateTo: fmt(now) };
    }
  }
};
